export const Burgerji = [
  {
    title: "meni.burgers.titles.hamburger",
    alergeni: "(1, 3, 5, 8, 9, 11, 12)",
    sestavine: "meni.burgers.sestavine.hamburger",
    cena: "9,30",
  },
  {
    title: "meni.burgers.titles.hamburgerham",
    alergeni: "(1, 3, 5, 8, 9, 11, 12)",
    sestavine: "meni.burgers.sestavine.hamburgerham",
    cena: "10,50",
  },
  {
    title: "meni.burgers.titles.cheeseburger",
    alergeni: "(1, 3, 5, 8, 9, 11, 12)",
    sestavine: "meni.burgers.sestavine.cheeseburger",
    cena: "9,80",
  },
  {
    title: "meni.burgers.titles.cheeseburgerham",
    alergeni: "(1, 3, 5, 8, 9, 11, 12)",
    sestavine: "meni.burgers.sestavine.cheeseburgerham",
    cena: "10,90",
  },
  {
    title: "meni.burgers.titles.vegi",
    alergeni: "(1, 3, 5, 11, 12)",
    sestavine: "meni.burgers.sestavine.vegi",
    cena: "10,00",
  },
  {
    title: "meni.burgers.titles.vegicheese",
    alergeni: "(1, 3, 5, 11, 12)",
    sestavine: "meni.burgers.sestavine.vegicheese",
    cena: "10,90",
  },
];

export const Pizze = [
  {
    title: "meni.pizze.titles.picici",
    alergeni: "",
    sestavine: "meni.pizze.alergeni.picici",
    cenaMala: "-----",
    cenaVelika: "10,80",
  },
  {
    title: "meni.pizze.titles.picici_slanina",
    alergeni: "",
    sestavine: "meni.pizze.alergeni.picici_slanina",
    cenaMala: "-----",
    cenaVelika: "12,50",
  },
  {
    title: "meni.pizze.titles.margerita",
    alergeni: "(1, 5, 10)",
    sestavine: "meni.pizze.alergeni.margerita",
    cenaMala: "9,30",
    cenaVelika: "9,80",
  },
  {
    title: "meni.pizze.titles.tanavadna",
    alergeni: "(1, 5, 8, 9, 10)",
    sestavine: "meni.pizze.alergeni.tanavadna",
    cenaMala: "9,80",
    cenaVelika: "10,80",
  },
  {
    title: "meni.pizze.titles.toplar",
    alergeni: "(1, 5, 8, 9, 10)",
    sestavine: "meni.pizze.alergeni.toplar",
    cenaMala: "11,00",
    cenaVelika: "12,00",
  },
  {
    title: "meni.pizze.titles.neza",
    alergeni: "(1, 5, 8, 9, 10)",
    sestavine: "meni.pizze.alergeni.neza",
    cenaMala: "11,00",
    cenaVelika: "12,00",
  },
  {
    title: "meni.pizze.titles.cesencek",
    alergeni: "(1, 5, 8, 9, 10)",
    sestavine: "meni.pizze.alergeni.cesencek",
    cenaMala: "11,20",
    cenaVelika: "12,40",
  },
  {
    title: "meni.pizze.titles.kmecka",
    alergeni: "(1, 5, 8, 9, 10)",
    sestavine: "meni.pizze.alergeni.kmecka",
    cenaMala: "11,20",
    cenaVelika: "12,40",
  },
  {
    title: "meni.pizze.titles.murje",
    alergeni: "(1, 2, 4, 5, 6)",
    sestavine: "meni.pizze.alergeni.murje",
    cenaMala: "11,20",
    cenaVelika: "12,40",
  },
  {
    title: "meni.pizze.titles.tunca",
    alergeni: "(1, 2, 4, 5, 6)",
    sestavine: "meni.pizze.alergeni.tunca",
    cenaMala: "11,20",
    cenaVelika: "12,40",
  },
  {
    title: "meni.pizze.titles.kraska",
    alergeni: "(1, 5, 9, 10)",
    sestavine: "meni.pizze.alergeni.kraska",
    cenaMala: "11,20",
    cenaVelika: "12,40",
  },
  {
    title: "meni.pizze.titles.hudicek",
    alergeni: "(1, 5, 8, 9, 10)",
    sestavine: "meni.pizze.alergeni.hudicek",
    cenaMala: "11,20",
    cenaVelika: "12,40",
  },
  {
    title: "meni.pizze.titles.mehiska",
    alergeni: "(1, 5, 8, 9, 10)",
    sestavine: "meni.pizze.alergeni.mehiska",
    cenaMala: "11,80",
    cenaVelika: "12,90",
  },
  {
    title: "meni.pizze.titles.stirjesiri",
    alergeni: "(1, 5, 10)",
    sestavine: "meni.pizze.alergeni.stirjesiri",
    cenaMala: "11,20",
    cenaVelika: "12,00",
  },
  {
    title: "meni.pizze.titles.vegi",
    alergeni: "(1, 5, 10)",
    sestavine: "meni.pizze.alergeni.vegi",
    cenaMala: "11,20",
    cenaVelika: "12,40",
  },
  {
    title: "meni.pizze.titles.poletna",
    alergeni: "(1, 5, 8, 9, 10)",
    sestavine: "meni.pizze.alergeni.poletna",
    cenaMala: "11,80",
    cenaVelika: "12,90",
  },
  {
    title: "meni.pizze.titles.jurcek",
    alergeni: "(1, 5, 8, 9, 10)",
    sestavine: "meni.pizze.alergeni.jurcek",
    cenaMala: "11,80",
    cenaVelika: "12,90",
  },
  {
    title: "meni.pizze.titles.napalavica",
    alergeni: "(1 - 12)",
    sestavine: "meni.pizze.alergeni.napalavica",
    cenaMala: "12,90",
    cenaVelika: "13,90",
  },
];

export const Dodatki = [
  {
    title: "Artičoke",
    alergeni: "",
    cena: "2,20",
  },
  {
    title: "Hrenovke",
    alergeni: "(8, 9)",
    cena: "2,20",
  },
  {
    title: "Jajce",
    alergeni: "(3)",
    cena: "2,00",
  },
  {
    title: "Kisla smetana",
    alergeni: "(5)",
    cena: "2,00",
  },
  {
    title: "Koruza",
    alergeni: "(1)",
    cena: "1,80",
  },
  {
    title: "Morski sadeži",
    alergeni: "(2, 4, 6)",
    cena: "2,20",
  },
  {
    title: "Nacho sir",
    alergeni: "(5, 9)",
    cena: "2,20",
  },
  {
    title: "Olive",
    alergeni: "(9)",
    cena: "2,00",
  },
  {
    title: "Paprika",
    alergeni: "",
    cena: "2,00",
  },
  {
    title: "Paradižnik",
    alergeni: "",
    cena: "2,00",
  },
  {
    title: "Pelati",
    alergeni: "(9)",
    cena: "2,00",
  },
  {
    title: "Pršut",
    alergeni: "(9)",
    cena: "2,20",
  },
  {
    title: "Sir",
    alergeni: "(1, 5, 8, 9)",
    cena: "2,00",
  },
  {
    title: "Slanina",
    alergeni: "(8, 9)",
    cena: "2,20",
  },
  {
    title: "Šunka",
    alergeni: "(8, 9)",
    cena: "2,00",
  },
  {
    title: "Tatarska omaka",
    alergeni: "(3, 5, 9)",
    cena: "2,20",
  },
  {
    title: "Tržaška omaka",
    alergeni: "",
    cena: "2,20",
  },
  {
    title: "Tuna",
    alergeni: "(2, 4, 6)",
    cena: "2,20",
  },
  {
    title: "Embalaža",
    alergeni: "",
    cena: "1,00",
  },
];

export const Alergeni = [
  {
    title: "Žita, ki vsebujejo gluten",
    številka: "1",
  },
  {
    title: "Raki",
    številka: "2",
  },
  {
    title: "Jajca in izdelki iz njih",
    številka: "3",
  },
  {
    title: "Ribe",
    številka: "4",
  },
  {
    title: "Mleko in mlečni izdelki",
    številka: "5",
  },
  {
    title: "Mehkužci",
    številka: "6",
  },
  {
    title: "Oreščki",
    številka: "7",
  },
  {
    title: "Soja",
    številka: "8",
  },
  {
    title: "Žveplov dioksid in sulfiti",
    številka: "9",
  },
  {
    title: "Gobe",
    številka: "10",
  },
  {
    title: "Sezamovo seme",
    številka: "11",
  },
  {
    title: "Gorčično seme",
    številka: "12",
  },
];

export const DrugaPonudba = [
  {
    title: "Toast s šunko in sirom",
    alergeni: "1, 3, 5, 8 ,9",
    sestavine: "",
    cena: "2,00",
  },
  {
    title: "Klobasa",
    alergeni: "1, 5, 8, 9, 12",
    sestavine: "Kruh, ajvar, gorčica, hren",
    cena: "9,80",
  },
  {
    title: "Sladoled",
    alergeni: "1, 3, 5, 7, 9",
    sestavine: "",
    cena: "2,60",
  },
];

/* export const TopliNapitki = [
  {
    title: "Kava espresso",
    alergeni: "",
    sestavine: "",
    cena: "1,30",
  },
  {
    title: "Cappuccino",
    alergeni: "(5)",
    sestavine: "",
    cena: "1,50",
  },
  {
    title: "Kava s smetano",
    alergeni: "(5)",
    sestavine: "",
    cena: "1,50",
  },
  {
    title: "Kava z mlekom",
    alergeni: "(5)",
    sestavine: "",
    cena: "1,50",
  },
  {
    title: "Bela kava",
    alergeni: "(5)",
    sestavine: "",
    cena: "1,70",
  },
  {
    title: "Bela kava s smetano",
    alergeni: "(5)",
    sestavine: "",
    cena: "1,90",
  },
  {
    title: "Brezkofeinska kava",
    alergeni: "",
    sestavine: "",
    cena: "1,30",
  },
  {
    title: "Kava za s seboj",
    alergeni: "",
    sestavine: "",
    cena: "1,30",
  },
  {
    title: "Kakav",
    alergeni: "(5, 8)",
    sestavine: "",
    cena: "1,70",
  },
  {
    title: "Kakav s smetano",
    alergeni: "(5, 8)",
    sestavine: "",
    cena: "1,90",
  },
  {
    title: "Vroča čokolada",
    alergeni: "(1, 3, 5, 7, 8)",
    sestavine: "",
    cena: "2,10",
  },
  {
    title: "Vroča čokolada s smetano",
    alergeni: "(1, 3, 5, 7, 8)",
    sestavine: "",
    cena: "2,30",
  },
  {
    title: "Čaj",
    alergeni: "",
    sestavine: "",
    cena: "1,60",
  },
  {
    title: "Čaj z mlekom",
    alergeni: "(5)",
    sestavine: "",
    cena: "1,70",
  },
  {
    title: "Čaj z limono",
    alergeni: "",
    sestavine: "",
    cena: "1,80",
  },
  {
    title: "Čaj z medom",
    alergeni: "",
    sestavine: "",
    cena: "1,80",
  },
  {
    title: "Čaj z limono in medom",
    alergeni: "",
    sestavine: "",
    cena: "2,00",
  },
  {
    title: "Kuhano vino",
    alergeni: "(9)",
    sestavine: "",
    cena: "2,50",
  },
]; */

/* export const BrezalkoholnePijace = [
  {
    title: "Voda",
    alergeni: "",
    kolicina: "0,5l",
    cena: "1,60",
  },
  {
    title: "Voda z okusom",
    alergeni: "",
    kolicina: "0,5l",
    cena: "1,70",
  },
  {
    title: "Radenska",
    alergeni: "",
    kolicina: "0,1l",
    cena: "0,70",
  },
  {
    title: "Radenska",
    alergeni: "",
    kolicina: "0,25l",
    cena: "1,60",
  },
  {
    title: "Limonada",
    alergeni: "",
    kolicina: "0,2l",
    cena: "2,20",
  },
  {
    title: "Jabolčni sok",
    alergeni: "",
    kolicina: "0,1l",
    cena: "1,10",
  },
  {
    title: "Pomarančni sok",
    alergeni: "",
    kolicina: "0,1l",
    cena: "1,10",
  },
  {
    title: "Cockta",
    alergeni: "",
    kolicina: "0,25l",
    cena: "2,10",
  },
  {
    title: "Coca cola",
    alergeni: "",
    kolicina: "0,1l",
    cena: "1,10",
  },
  {
    title: "Coca cola",
    alergeni: "",
    kolicina: "0,25l",
    cena: "1,60",
  },
  {
    title: "Fanta",
    alergeni: "",
    kolicina: "0,1l",
    cena: "1,10",
  },
  {
    title: "Fanta",
    alergeni: "",
    kolicina: "0,25l",
    cena: "2,10",
  },
  {
    title: "Radenska z okusom",
    alergeni: "",
    kolicina: "0,25l",
    cena: "1,90",
  },
  {
    title: "Sprite",
    alergeni: "",
    kolicina: "0,25l",
    cena: "2,10",
  },
  {
    title: "Schweppes",
    alergeni: "",
    kolicina: "0,1l",
    cena: "1,10",
  },
  {
    title: "Schweppes",
    alergeni: "",
    kolicina: "0,25l",
    cena: "2,10",
  },
  {
    title: "Ledeni čaj",
    alergeni: "",
    kolicina: "0,25l",
    cena: "2,20",
  },
  {
    title: "Multi Sola",
    alergeni: "",
    kolicina: "0,25l",
    cena: "2,20",
  },
  {
    title: "Sok v steklenici",
    alergeni: "",
    kolicina: "0,33l",
    cena: "2,30",
  },
  {
    title: "Cedevita",
    alergeni: "",
    kolicina: "0,2l",
    cena: "1,90",
  },
  {
    title: "Red Bull",
    alergeni: "",
    kolicina: "0,33",
    cena: "3,10",
  },
];

export const Pivo = [
  {
    title: "Laško, točeno",
    alergeni: "",
    kolicina: "0,2l",
    cena: "1,90",
  },
  {
    title: "Laško, točeno",
    alergeni: "",
    kolicina: "0,3l",
    cena: "2,30",
  },
  {
    title: "Laško, točeno",
    alergeni: "",
    kolicina: "0,5l",
    cena: "2,50",
  },
  {
    title: "Laško, temno",
    alergeni: "",
    kolicina: "0,5l",
    cena: "2,50",
  },
  {
    title: "Union",
    alergeni: "",
    kolicina: "0,33l",
    cena: "2,30",
  },
  {
    title: "Union",
    alergeni: "",
    kolicina: "0,5l",
    cena: "2,50",
  },
  {
    title: "Union, nefiltrirano",
    alergeni: "",
    kolicina: "0,5l",
    cena: "2,80",
  },
  {
    title: "Union, nefiltrirano",
    alergeni: "",
    kolicina: "0,5l",
    cena: "2,80",
  },
  {
    title: "Heineken",
    alergeni: "",
    kolicina: "0,4l",
    cena: "3,10",
  },
  {
    title: "Radler",
    alergeni: "",
    kolicina: "0,5l",
    cena: "2,40",
  },
  {
    title: "Brezalkoholno pivo",
    alergeni: "",
    kolicina: "0,5l",
    cena: "2,40",
  },
];

export const Vino = [
  {
    title: "Cviček PTP",
    alergeni: "suho",
    kolicina: "0,1l",
    cena: "1,20",
  },
  {
    title: "Martini Bianco",
    alergeni: "desertno",
    kolicina: "0,1l",
    cena: "3,20",
  },
  {
    title: "Belokranjec PTP",
    alergeni: "suho",
    kolicina: "0,1l",
    cena: "1,20",
  },
  {
    title: "Möttling",
    alergeni: "polsuho",
    kolicina: "0,1l",
    cena: "1,40",
  },
  {
    title: "Rumeni muškat",
    alergeni: "polsladko",
    kolicina: "0,1l",
    cena: "2,00",
  },
  {
    title: "Chardonnay",
    alergeni: "suho",
    kolicina: "0,75l",
    cena: "20,00",
  },
  {
    title: "Rumeni muškat Kolednik",
    alergeni: "sladko",
    kolicina: "0,75l",
    cena: "22,00",
  },
  {
    title: "Metliška črnina PTP",
    alergeni: "suho",
    kolicina: "0,1l",
    cena: "1,30",
  },
  {
    title: "Portugalka",
    alergeni: "suho",
    kolicina: "0,1l",
    cena: "1,30",
  },
  {
    title: "Modra frankinja",
    alergeni: "suho",
    kolicina: "0,75l",
    cena: "20,00",
  },
  {
    title: "Metliška penina",
    alergeni: "polsuho",
    kolicina: "0,75l",
    cena: "20,00",
  },
];

export const Zgane = [
  {
    title: "Borovničevec",
    alergeni: "",
    kolicina: "0,03l",
    cena: "2,20",
  },
  {
    title: "Cynar",
    alergeni: "",
    kolicina: "0,03l",
    cena: "2,20",
  },
  {
    title: "Pelinkovec",
    alergeni: "",
    kolicina: "0,03l",
    cena: "2,20",
  },
  {
    title: "Rum",
    alergeni: "",
    kolicina: "0,03l",
    cena: "2,20",
  },
  {
    title: "Sadjevec",
    alergeni: "",
    kolicina: "0,03l",
    cena: "2,20",
  },
  {
    title: "Travarica",
    alergeni: "",
    kolicina: "0,03l",
    cena: "2,20",
  },
  {
    title: "Vodka",
    alergeni: "",
    kolicina: "0,03l",
    cena: "2,20",
  },
  {
    title: "Bacardi",
    alergeni: "",
    kolicina: "0,03l",
    cena: "2,20",
  },
  {
    title: "Brinjevec",
    alergeni: "",
    kolicina: "0,03l",
    cena: "2,40",
  },
  {
    title: "Gin",
    alergeni: "",
    kolicina: "0,03l",
    cena: "2,80",
  },
  {
    title: "London Gin",
    alergeni: "",
    kolicina: "0,03l",
    cena: "3,20",
  },
  {
    title: "Jägermeister",
    alergeni: "",
    kolicina: "0,03l",
    cena: "2,70",
  },
  {
    title: "Malibu",
    alergeni: "",
    kolicina: "0,03l",
    cena: "2,40",
  },
  {
    title: "Stock",
    alergeni: "",
    kolicina: "0,03l",
    cena: "2,40",
  },
  {
    title: "Viljamovka",
    alergeni: "",
    kolicina: "0,03l",
    cena: "2,80",
  },
  {
    title: "Carolans",
    alergeni: "",
    kolicina: "0,03l",
    cena: "2,60",
  },
  {
    title: "Likerji Beryshka",
    alergeni: "Orehov, aronijev, borovničev, češnjev, ribezov, robidov",
    kolicina: "0,03l",
    cena: "3,20",
  },
];

export const Viskiji = [
  {
    title: "Jack Daniels",
    alergeni: "Ameriški whisky",
    kolicina: "0,03l",
    cena: "3,00",
  },
  {
    title: "Jameson",
    alergeni: "Irski whisky",
    kolicina: "0,03l",
    cena: "3,00",
  },
  {
    title: "Johnnie Walker",
    alergeni: "Škotski whisky",
    kolicina: "0,03l",
    cena: "2,80",
  },
  {
    title: "Chivas Regal",
    alergeni: "Škotski whisky",
    kolicina: "0,03l",
    cena: "3,80",
  },
  {
    title: "Canadian Club",
    alergeni: "Kanadski whisky",
    kolicina: "0,03l",
    cena: "2,80",
  },
]; */
